import { styled } from '@mui/material';

export const PickUpSlotsWrapper = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '20px 12px',
  alignItems: 'center',
  justifyContent: 'stretch',
}));
